import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { isEmpty } from 'lodash'

import { Checkbox } from 'components/v2/Checkbox'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { useCompanyLinesAutocompleteQuery } from 'features/Lines/hooks'

const CheckboxWrapper = styled.div<TSFixMe>`
  margin-bottom: 10px;

  :last-child {
    margin-bottom: 0;
  }
`
export const CompanyLinesCheckboxes = ({ companyLineIds = [], companyId, ...props }: TSFixMe): TSFixMe => {
  const { companyLines, loading, error, refetch } = useCompanyLinesAutocompleteQuery({ companyId })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  const handleChange = ({ target: { id } }: TSFixMe): TSFixMe => {
    let newCompanyLineIds

    if (companyLineIds.indexOf(id) === -1) {
      newCompanyLineIds = [...companyLineIds, id]
    } else {
      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      newCompanyLineIds = companyLineIds.filter((value): TSFixMe => value !== id)
    }

    props.onChange(newCompanyLineIds)
  }

  if (loading) {
    return (
      <div>
        <FormattedMessage id="companyLines.checkboxes.loading" defaultMessage="Loading ..." />
      </div>
    )
  } else if (error) {
    return (
      <div>
        <FormattedMessage id="companyLines.checkboxes.error" defaultMessage="Error while loading your lines" />
      </div>
    )
  } else if (isEmpty(companyLines)) {
    return (
      <div>
        <FormattedMessage id="companyLines.checkboxes.empty" defaultMessage="You need to create a line first" />
      </div>
    )
  }

  return (
    <div>
      {companyLines.map((companyLine): TSFixMe => {
        return (
          <CheckboxWrapper key={companyLine.id}>
            <Checkbox id={companyLine.id} checked={companyLineIds.indexOf(companyLine.id) > -1} onChange={handleChange}>
              {companyLine.name}
            </Checkbox>
          </CheckboxWrapper>
        )
      })}

      {props.touched && props.errors && <ErrorMessage>{props.errors}</ErrorMessage>}
    </div>
  )
}
